import { createFileRoute } from '@tanstack/react-router'
import type { Id } from '@convex/_generated/dataModel'
import { ListDetail } from '@/features/lists/ListDetail'

export const Route = createFileRoute('/lists/$listId')({
  component: ListPage,
})

function ListPage() {
  const { listId } = Route.useParams()
  // The heading is the list's own editable name, so this page does not use
  // PageHeading — the title *is* a control here rather than a label.
  return (
    <div className="py-6 sm:py-8">
      <ListDetail listId={listId as Id<'lists'>} />
    </div>
  )
}
